import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    TAGS_QUERY,
    SINGLE_TAG_QUERY,
    CREATE_TAG_MUTATION,
    UPDATE_TAG_MUTATION,
    DELETE_TAG_MUTATION
} from "@/graphql/tags.js";

const state = {
    tags: []
};

const getters = {};

const mutations = {
    [types.SET_TAGS](state, tags) {
        state.tags = tags;
    },
    [types.SORT_TAGS](state) {
        state.tags.sort(function(a, b) {
            return a.node.orderId ==
                b.node.orderId
                ? 0
                : a.node.orderId >
                  b.node.orderId
                ? 1
                : -1;
        });
    },
    [types.UPSERT_TAG](state, tag) {
        var index = state.tags.findIndex(function(element) {
            return element.node.id == tag.id;
        });

        const node = { node: tag };

        if (index > -1) {
            state.tags.splice(index, 1, node);
        } else {
            state.tags.unshift(node);
        }
    },
    [types.DELETE_TAG](state, tag) {
        var index = state.tags.find(function(element, index) {
            if (element.id == tag.id) {
                return index;
            }
        });

        if (index > -1) {
            state.tags.splice(index, 1);
        }
    }
};

const actions = {
    async fetchTags(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: TAGS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const tags = response.data.tenantTags.edges;

                    // update store
                    context.commit(types.SET_TAGS, tags);

                    // sort
                    context.commit(types.SORT_TAGS);

                    resolve(tags);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_TAG_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const tag = response.data.tag;

                    // update store
                    context.commit(types.UPSERT_TAG, tag);

                    // sort
                    context.commit(types.SORT_TAGS);

                    resolve(tag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_TAG_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const tag = response.data.createTag.tag;

                    // update store
                    context.commit(types.UPSERT_TAG, tag);

                    // sort
                    context.commit(types.SORT_TAGS);

                    resolve(tag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_TAG_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const tag = response.data.updateTag.tag;

                    // update store
                    context.commit(types.UPSERT_TAG, tag);

                    // sort
                    context.commit(types.SORT_TAGS);

                    resolve(tag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_TAG_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const tag = response.data.deleteTag.tag;

                    // update store
                    context.commit(types.DELETE_TAG, tag);

                    resolve(tag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
